import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {useStyles} from './VoicemailButton.utils';
import {ReactComponent as VoicemailIcon} from '../../assets/VoicemailBlue.svg';
import {actions} from '../../store';
import {ReduxState} from '../../store/types';
import {VoicemailsDialogProps} from './VoicemailsDialog.utils';
import VoicemailsDialog from './VoicemailsDialog';

export type VoicemailButtonProps = {
    i_account: number | undefined,
    unifiedMessagingEnabled: boolean,
    extensionId: string | undefined,
    extensionName: string | undefined,
};

const VoicemailButton: React.VFC<VoicemailButtonProps> = ({
    i_account,
    unifiedMessagingEnabled,
    extensionId,
    extensionName
}) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const {t} = useTranslation();
    
    const {accountVoicemails} = useSelector((state: ReduxState) => state.voicemails);

    const fetchData = useCallback(() => {
        if(i_account) {
            dispatch(actions.getVoicemailList.request({
                i_account: i_account
            }));
        }
    }, [i_account]);

    const [dialogProps, setDialogProps] = useState<VoicemailsDialogProps>({
        isOpen: false,
        i_account: i_account,
        toggleVisibility: () => {;},
        extensionId: extensionId,
        extensionName: extensionName,
        fetchData: fetchData,
    } as VoicemailsDialogProps);

    useEffect(() => {
        fetchData();
    }, [i_account, fetchData]);

    const handleOpenDialog = useCallback(() => {
        setDialogProps({
            ...dialogProps,
            isOpen: !dialogProps.isOpen,
            toggleVisibility: () => {
                setDialogProps({
                    ...dialogProps,
                    isOpen: false
                })
            }
        })
    }, [dialogProps, setDialogProps])

    const counterToDisplay = useMemo(() => {
        const voicemails = accountVoicemails
            ?.filter(e => e.i_account == i_account)
            ?.[0]?.voicemails
            ?.filter(e => e.flags?.includes("\\Recent"));
        return voicemails?.length ?? 0;
    }, [accountVoicemails, i_account]);
    
    if(!unifiedMessagingEnabled) {
        return <></>;
    }

    return (<div id={"voicemails-button-" + extensionId} className={classes.container} onClick={(e) => {
        //@ts-ignore
        const id = e.target?.['id'] ?? '';
        //@ts-ignore
        const classList = e.target?.classList;
        const subElements = [
            "voicemails-button-" + extensionId,
            "voicemails-icon-button-" + extensionId,
            "voicemails-label-" + extensionId,
            "voicemails-badge-" + extensionId
        ];
        if (subElements.includes(id) || classList?.contains('MuiDialog-scrollPaper')) {
            handleOpenDialog();
        }
    }}>
        <div className={classes.iconContainer} id={"voicemails-icon-button-" + extensionId}><VoicemailIcon className={classes.icon}/></div>
        <div className={classes.label} id={"voicemails-label-" + extensionId}>{t('screens:voicemails.voicemail')}</div>
        {(counterToDisplay > 0) && (<div className={classes.badge} id={"voicemails-badge-" + extensionId}>{counterToDisplay}</div>)}
        <VoicemailsDialog {...dialogProps} />
    </div>);
};

export default VoicemailButton;